import PropTypes from 'prop-types'
import styled from 'styled-components'
import IconLink from 'components/Shared/IconLink/Index'
import colors from 'components/utils/colors'
import Tooltip from 'components/Shared/Tooltip/Index'

// 'order: 1' to move icon to the right of dropdown icon
export const StyledClearIndicator = styled(IconLink)`
  padding: 2px;
  order: 1;
  border-radius: 50%;
  margin-left: 2px;

  &:before {
    color: ${colors.secondary70} !important;
  }

  &:hover:before {
    color: red !important;
  }
`

const ClearIndicator = (props) => {
  const { innerProps } = props
  const clearActionTooltip = props.selectProps.clearActionTooltip

  return (
    <>
      <StyledClearIndicator
        {...innerProps}
        iconName='icon-close-filters-12'
        data-tooltip-content={clearActionTooltip}
        data-tooltip-id='tooltip-clear-action'
      />
      <Tooltip id='tooltip-clear-action' />
    </>
  )
}

ClearIndicator.propTypes = {
  innerProps: PropTypes.object,
  selectProps: PropTypes.object,
}

export default ClearIndicator
